import React, {useState} from 'react';
import {Button, Grid, Icon, Image, Modal} from 'semantic-ui-react';
import {dir} from "../../constants";
import Loading from "../Loading";
import {arrayBufferToBase64} from "../../utils/genericUtils";
import {filesActions} from "../../behavior/files";
import {connect} from "react-redux";

export const ImageViewerModal = ({file, fileList, filePreview, filePreviewIsLoading, downloadAsBA, setIsPreviewShown, compactTrigger, api}) => {
	const [active, setActive] = useState(false);
	const [rotation, setRotation] = useState(0);
	const [previewIndex, setPreviewIndex] = useState(0);

    const processedFilePreview = arrayBufferToBase64(filePreview);

    const imageViewerModalTrigger =
        <Button icon='eye' compact={compactTrigger} size='mini' onClick={()=>{
            setActive(false);
            setPreviewIndex(fileList.findIndex((idx) => idx.id === file.id));
            setIsPreviewShown(true);
						downloadAsBA(api, file.id);
        }}/>;

    const updateRotation = (direction) => {
        let newRotation = rotation;
        if (direction === dir.right) {
            newRotation = newRotation + 90;
        } else if (direction === dir.left) {
            newRotation = newRotation - 90;
        }
        newRotation = newRotation % 360;
        setRotation(newRotation);
    };

    const changePhoto = (direction) => {
        let newIndex = previewIndex;
        if (direction === dir.right) {
            newIndex = newIndex + 1;
        } else if (direction === dir.left) {
            newIndex = newIndex - 1;
        }
        newIndex = (newIndex + fileList.length) % fileList.length;
        setPreviewIndex(newIndex);
        setRotation(0);
				downloadAsBA(api, fileList[newIndex].id);
    };

    const imageViewerModal =
        <Modal
            basic
            trigger={imageViewerModalTrigger}
            closeIcon
            onClose={() => {
                setRotation(0);
                setIsPreviewShown(false);
            }}
        >
            <Modal.Header>{fileList[previewIndex] && fileList[previewIndex].name}</Modal.Header>
            <Modal.Content image size='large'>
                <Loading isLoading={filePreviewIsLoading}/>
                {!filePreviewIsLoading && <Grid>
                    <Grid.Row style={{padding: 0, margin: 0}}>
                        <Grid.Column width={2} style={{
                            padding: '300px 0 0 0', margin: 0,
                            float: 'right',
                            textAlign: 'right',
                            align: 'right'
                        }}>
                            {
                                previewIndex !== 0 &&
                                <Icon
                                    name='angle left'
                                    size='huge'
                                    style={{cursor: 'pointer', margin: 0, padding: 0}}
                                    onClick={() => changePhoto(dir.left)}
                                />
                            }
                        </Grid.Column>
                        <Grid.Column width={12} style={{padding: 0, margin: 0}}>
                            <Grid style={{padding: 0, margin: 0}}>
                                <Grid.Row style={{padding: 0, margin: 0, height: '665px'}}>
                                    <Grid.Column style={{
                                        padding: 0,
                                        textAlign: 'center',
                                        display: 'block',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: 'auto'
                                    }}>
                                        <Image
                                            className={'imageViewContainer'}
                                            wrapped
                                            src={processedFilePreview}
                                            style={{transform: `rotate(${rotation}deg)`, maxHeight: '665px'}}
                                            centered
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row style={{padding: '10px 0 0 0', margin: 0, marginLeft: '300px'}}>
                                    <Grid.Column style={{padding: 0, margin: 0}}>
                                        <Icon
                                            name='undo'
                                            size='large'
                                            style={{paddingRight: '50px', cursor: 'pointer'}}
                                            onClick={() => updateRotation(dir.left)}
                                        />
                                        <Icon
                                            name='redo'
                                            size='large'
                                            style={{cursor: 'pointer'}}
                                            onClick={() => updateRotation(dir.right)}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Grid.Column>
                        <Grid.Column width={2} style={{padding: '300px 0 0 0', margin: 0}}>
                            {
                                previewIndex !== fileList.length - 1 &&
                                <Icon
                                    name='angle right'
                                    size='huge'
                                    style={{cursor: 'pointer'}}
                                    onClick={() => changePhoto(dir.right)}
                                />
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                }
            </Modal.Content>
        </Modal>;

	return imageViewerModal;
};

ImageViewerModal.defaultProps = {
	compactTrigger: true,

	//if one file is provided only, these can remain as is
	setIsPreviewShown:() => null,
	fileList:[{}]
};

const mapStateToProps = (state, ownProps) => ({
	filePreview: state.files.filePreview,
	filePreviewIsLoading: state.files.isLoading
});

const mapDispatchToProps = dispatch => ({
	download: (api, fileId) => dispatch(filesActions.download(api, fileId)),
	downloadAsBA: (api, fileId, isThumbnail) => dispatch(filesActions.downloadAsBA(api, fileId, isThumbnail)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ImageViewerModal);

